// Trims and lowercases email. Returns undefined if empty or only whitespace.
export function normalizeEmail(input?: string): string | undefined {
  const result = (input || "").trim().toLowerCase();
  return result === "" ? undefined : result;
}

/** Slovak and Czech subscriber numbers are nine digits after the prefix. */
const NINE_DIGIT_PREFIXES = ["421", "420"];

/**
 * Turns a phone number the way people type it into E.164 (+421905123456), or
 * undefined when it is not a number we can send an SMS to.
 *
 * Accepts the forms patients actually write: spaces, dashes, dots, slashes and
 * brackets ("+421 905 123 456", "0905/123 456"), the 00 prefix, and the
 * national form "0905 123 456", which is Slovak — the clinics are.
 * "+421 0905 …", the national number pasted after the prefix, drops the 0.
 */
export function normalizePhone(raw?: string): string | undefined {
  if (!raw) return undefined;
  let s = raw.replace(/[\s ().\/-]/g, "");
  if (!s) return undefined;

  if (s.startsWith("00")) s = "+" + s.slice(2);
  else if (s.startsWith("0")) s = "+421" + s.slice(1);
  if (!/^\+[1-9]\d+$/.test(s)) return undefined;

  const prefix = NINE_DIGIT_PREFIXES.find((p) => s.startsWith("+" + p));
  if (prefix) {
    let rest = s.slice(1 + prefix.length);
    if (rest.length === 10 && rest.startsWith("0")) rest = rest.slice(1);
    return rest.length === 9 ? `+${prefix}${rest}` : undefined;
  }

  // E.164 allows at most 15 digits; below 8 it is not a whole number.
  const digits = s.length - 1;
  return digits >= 8 && digits <= 15 ? s : undefined;
}

/** Shown wherever a phone number is refused, so the forms agree. */
export const INVALID_PHONE_MESSAGE =
  "Zadajte platné telefónne číslo, napr. 0901 234 567 alebo +421 901 234 567.";
